import { Grid, IconButton, Paper } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { PasswordBox } from '../../components/PasswordBox';
import { useMessageBox } from '../../context/MessageBox';
import Header from '../../layout/Header';
import Subheader from '../../layout/Subheader';
import api from '../../services/api';
import {
  logout,
  TOKEN_KEY,
  TOKEN_PAGINATION,
  TOKEN_PERMISSIONS,
  TOKEN_USER,
  TOKEN_WEB_SETTING,
} from '../../services/auth';
import { handleErrorRequest } from '../../utils/errorsValidation';
import * as S from './styles';
import { encrypt } from '../../services/crypto';

export function ChangePassword() {
  const history = useHistory();
  const { login, nome, loginId } = JSON.parse(sessionStorage.getItem('@Capittale-User'));
  const { setMessageData } = useMessageBox();
  const [formValue, setFormValue] = useState({});
  const [isLoading, setisLoading] = useState();
  const [open, setOpen] = useState(false);
  const [passwordRule, setPasswordRule] = useState();
  const [showConfirm, setShowConfirm] = useState(true);
  const [showOldPass, setShowOldPass] = useState(true);
  const [showPassword, setShowPassword] = useState(true);
  const [textOperatorBody, setTextOperatorBody] = useState('');

  const getPasswordRules = async () => {
    try {
      const response = await api.get('Logins/RegrasSenha');
      if (response.data.status === 'Sucesso') {
        setPasswordRule(response.data?.resposta?.retornoString);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onButtonClick = () => {
    const canRedirect = logout();
    if (canRedirect) {
      // sessionStorage.removeItem(TOKEN_KEY);
      // sessionStorage.removeItem(TOKEN_USER);
      // sessionStorage.removeItem(TOKEN_PERMISSIONS);
      // sessionStorage.removeItem(TOKEN_WEB_SETTING);
      // sessionStorage.removeItem(TOKEN_PAGINATION);
      history.push({
        pathname: '/app/login',
        state: {
          isPasswordChanged: true,
        },
      });
    }
  };

  const onSubmit = async () => {
    if (!formValue.senhaAtual || !formValue.senhaNova || !formValue.senhaNovaConfirmacao) {
      return toast.error('Preencha todos os campos');
    }
    setisLoading(true);
    try {
      const response = await api.post('Logins/TrocarSenha', {
        loginId: loginId,
        senhaAtual: encrypt(formValue?.senhaAtual) || '',
        senhaNova: encrypt(formValue?.senhaNova) || '',
        senhaNovaConfirmacao: encrypt(formValue?.senhaNovaConfirmacao) || '',
        obrigaTrocarSenha: 'nao',
      });
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        console.log(response.data);
        // setMessageType('CHANGE_PASSWORD');
        setTextOperatorBody(response.data.resposta?.mensagemOperador);
        setOpen(true);
        toast.success('Troca de senha realizada com sucesso!');
        setFormValue({});
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      console.log(error);
    }
    setisLoading(false);
  };

  useEffect(() => {
    setFormValue({});
    getPasswordRules();
  }, []);

  return (
    <S.Root>
      <Header />
      <Subheader title="Alterar senha" back="/app/home" />
      <S.Content>
        <div className="message-html" dangerouslySetInnerHTML={{ __html: passwordRule }}></div>
        <S.PasswordBox>
          <Grid container spacing={2} className="container-password">
            <Grid item xs={12}>
              <S.InputLabel>Usuário</S.InputLabel>
              <Paper elevation={0} className="input-paper">
                <S.InputText
                  disabled
                  name="usuario"
                  placeholder="Usuário"
                  value={nome}
                  inputProps={{
                    minLength: 3,
                    maxLength: 100,
                  }}
                />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <S.InputLabel>Login</S.InputLabel>
              <Paper elevation={0} className="input-paper">
                <S.InputText
                  disabled
                  value={login}
                  placeholder="Login"
                  name="login"
                  inputProps={{
                    minLength: 3,
                    maxLength: 100,
                  }}
                />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <S.InputLabel>Senha atual</S.InputLabel>
              <div>
                <Paper elevation={0} className="input-paper">
                  <S.InputText
                    autoFocus
                    name="senhaAtual"
                    value={formValue?.senhaAtual}
                    onChange={(e) => setFormValue({ ...formValue, senhaAtual: e.target.value })}
                    placeholder="Senha atual"
                    type={showOldPass ? 'password' : 'text'}
                    inputProps={{
                      autoComplete: 'new-password',
                      minLength: 3,
                      maxLength: 100,
                    }}
                  ></S.InputText>
                </Paper>
                <IconButton
                  className="icon-show"
                  onClick={() => setShowOldPass(!showOldPass)}
                  tabindex="-1"
                >
                  {showOldPass ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </div>
            </Grid>
            <Grid item xs={12}>
              <S.InputLabel>Nova senha</S.InputLabel>
              <div>
                <Paper elevation={0} className="input-paper">
                  <S.InputText
                    placeholder="Nova senha"
                    name="senhaNova"
                    value={formValue?.senhaNova}
                    onChange={(e) => setFormValue({ ...formValue, senhaNova: e.target.value })}
                    type={showPassword ? 'password' : 'text'}
                    inputProps={{
                      autoComplete: 'new-password',
                      minLength: 3,
                      maxLength: 100,
                    }}
                  />
                </Paper>
                <IconButton
                  className="icon-show"
                  onClick={() => setShowPassword(!showPassword)}
                  tabindex="-1"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </div>
            </Grid>
            <Grid item xs={12}>
              <S.InputLabel>Confirmação nova senha</S.InputLabel>
              <div>
                <Paper elevation={0} className="input-paper">
                  <S.InputText
                    value={formValue?.senhaNovaConfirmacao}
                    onChange={(e) =>
                      setFormValue({ ...formValue, senhaNovaConfirmacao: e.target.value })
                    }
                    placeholder="Confirmação nova senha"
                    type={showConfirm ? 'password' : 'text'}
                    inputProps={{
                      autoComplete: 'new-password',
                      minLength: 3,
                      maxLength: 100,
                    }}
                  />
                </Paper>
                <IconButton
                  className="icon-show"
                  onClick={() => setShowConfirm(!showConfirm)}
                  tabindex="-1"
                >
                  {showConfirm ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </div>
            </Grid>

            <S.ActionFooter>
              <S.ActionButton variant="contained" disabled={isLoading} onClick={onSubmit}>
                {isLoading ? 'Confirmando...' : 'Confirmar'}
              </S.ActionButton>
            </S.ActionFooter>
          </Grid>
        </S.PasswordBox>
      </S.Content>

      <PasswordBox callback={onButtonClick} open={open} textBody={textOperatorBody} />
    </S.Root>
  );
}
